/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../../../../../core/components';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html'
})
export class CheckoutComponent extends BaseComponent implements OnInit {
    /**
     * Store selected productId.
     */
    public productId: string = null;

    /**
     * Set if this is a checkout.
     */
    public checkout: boolean = false;

    constructor(
        private activatedRoute: ActivatedRoute
    ) {
        super();
    }

    ngOnInit(): void {
        const param: string = this.activatedRoute.snapshot.paramMap.get('param');
        if (param === 'cart') {
            this.checkout = true;
        } else {
            this.productId = param;
        }
    }
}
